import React from 'react';
import MaskedInput from 'react-text-mask';
import createNumberMask from 'text-mask-addons/dist/createNumberMask';

const Component = ({
  textAlign = 'left',
  fontSize = '36px',
  width = '100%',
  keyValue,
  ...props
}) => (
  <MaskedInput
    key={keyValue}
    style={{
      width,
      border: 'none',
      borderBottomWidth: '1px',
      borderBottomStyle: 'solid',
      borderBottomColor: '#767676',
      paddingRight: '12px',
      fontSize,
      textAlign,
    }}
    mask={createNumberMask({
      prefix: '$',
      allowDecimal: true,
    })}
    guide={false}
    maxLength={20}
    {...props}
  />
);

Component.displayName = 'CurrencyField';

export default Component;



// WEBPACK FOOTER //
// ./src/components/Forms/Controls/CurrencyField.js